import { render } from "./selector-salutation.vue?vue&type=template&id=216ffc55&scoped=true&ts=true"
import script from "./selector-salutation.vue?vue&type=script&lang=ts"
export * from "./selector-salutation.vue?vue&type=script&lang=ts"

import "./selector-salutation.vue?vue&type=style&index=0&id=216ffc55&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216ffc55"]])

export default __exports__